import { render, staticRenderFns } from "./reminder-item.vue?vue&type=template&id=46267ae4"
import script from "./reminder-item.vue?vue&type=script&lang=js"
export * from "./reminder-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports